import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CoreComponent } from './core.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { PaymentComponent } from './payment/payment.component';
import { SupportComponent } from './support/support.component';
import { TermsComponent } from './terms/terms.component';

const routes: Routes = [
    {
        path: '',
        component: CoreComponent,
        children: [
            {
                path: '',
                component: NotFoundComponent,
            },
            {
                path: 'product/:id',
                redirectTo: 'subscribe',
                pathMatch: 'full',
            },
            {
                path: 'subscribe',
                component: PaymentComponent,
            },
            {
                path: 'support',
                component: SupportComponent,
            },
            {
                path: 'terms',
                component: TermsComponent,
            },
            {
                path: '**',
                component: NotFoundComponent,
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class CoreRoutingModule {}
